import { Card } from '@seiue/ui'
import styled from 'styled-components'

export const ContentCard = styled(Card)`
  border-radius: 8px;
  width: 960px;
  flex-shrink: 0;
`
